// extracted by mini-css-extract-plugin
export default {"productDescription":"G--z","featuredDescription":"H--z","description":"I--z","more":"J--z","descriptionSku":"K--z"};